import ServiceCardV2 from '../ServiceCardV2'
import './styles.scss'

import missionIcon from '../../Assets/Images/mission-icon.png'
import vissionIcon from '../../Assets/Images/vision-icon.png'
import contactUsIcon from '../../Assets/Images/contact-us-icon.png'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from '../../constants'
import AnimateOnScroll from '../AnimateOnScroll'

const UnbeatableSection = () => {
  const navigate = useNavigate()

  const goToAboutUs = () => navigate(ROUTES.about)

  const goToContactUs = () => navigate(ROUTES.contact)

  const goToTrackIt = () => navigate(ROUTES.trackIt)

  return (
    <section className="unbeatable-section">
      <AnimateOnScroll animation="fade-right" className="info">
        <h2>Unbeatable Courier Services</h2>

        <p>
          When you need it there today and not overnight, your shipment will be
          picked up and delivered across the UK and internationally on a direct,
          reliable service.
        </p>
      </AnimateOnScroll>

      <AnimateOnScroll animation="fade-left" delay={200} className="service-cards">
        <ServiceCardV2
          label="Tracking"
          icon={<img src={missionIcon} alt="" />}
          onClick={goToTrackIt}
        />

        <ServiceCardV2
          label="Read More"
          icon={<img src={vissionIcon} alt="" />}
          onClick={goToAboutUs}
        />

        <ServiceCardV2
          label="Contact Us"
          icon={<img src={contactUsIcon} alt="" />}
          onClick={goToContactUs}
        />
      </AnimateOnScroll>
    </section>
  )
}

export default UnbeatableSection
